// src/app/config/customer1.config.ts

import {CustomerConfig} from "../CustomerConfig";

// PUM Config
export const customer2Config: CustomerConfig = {
  icons: {
    favIcon: 'Logo_Parken_Management_RGB.svg',
    icon: 'Logo_Parken_Management_RGB.svg',
  },
  strings: {
    title: 'Parkticket online bezahlen | Parken Management Payment',
    footerText: "test",
    email: "info@parken-und-management.de",
    number: "08273 994211 94001",
    contactRef: "https://parken-und-management.de/impressum/",
    dataProtectionRef: "https://parken-und-management.de/datenschutz/",
    metaDescription: "Parkticket jetzt online bezahlen mit Parken und Management – einfach, sicher & ohne Registrierung über payment.parken-und-management.de. Kennzeichen eingeben, Zahlung abschließen & weiterfahren.",
  }
};
